import styled from 'styled-components';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

export const Wrapper = styled.div`
    height: 30px;
    background-color: ${({ theme }) => theme.colors.blue};
    width: 100%;
`;

export const StyledLink = styled.div`
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  height: 30px;
  display: flex;
  align-items: center;
`;

export const StyledArrowBackIcon = styled(ArrowBackIcon)`
    width: 10px;
    height: 10px;
    margin: 0 ${({ theme }) => theme.spacing * 3}px 0 0;
`;
